.vendor-lead-billing-info-content__container {
  height: 100%;
  padding: 24px 0;

  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: stretch;

  gap: 32px;
}

.vendor-lead-billing-info-content__container .vendor-lead-billing-info-content__container__block {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;

  // Non-standard. This prevents overlapping of input error message
  gap: 18px;
}

.vendor-lead-billing-info-content__container .vendor-lead-billing-info-content__container__row {
  width: 100%;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
}

.vendor-lead-billing-info-content__container .vendor-lead-billing-info-content__container__subrow {
  width: 100%;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
}

.vendor-lead-billing-info-content__container .vendor-lead-billing-info-content__container__tag-options-control {
  gap: 0
}

.vendor-lead-billing-info-content__container .vendor-lead-billing-info-content__container__tag-options {
  flex-wrap: nowrap;
  gap: 16px;
}

.vendor-lead-billing-info-content__container .vendor-lead-billing-info-content__container__tag-option {
  width: unset;
  height: 56px; // Same as Select height
}

@media screen and (width <=640px) {
  .vendor-lead-billing-info-content__container {
    flex-flow: column nowrap;
    align-items: stretch;
  }

  .vendor-lead-billing-info-content__container .vendor-lead-billing-info-content__container__row {
    flex-flow: column nowrap;
    align-items: stretch;
  }

  .vendor-lead-billing-info-content__container .vendor-lead-billing-info-content__container__tag-option {
    min-height: 56px; // Same as Select height
  }
}